import React, { useContext, useState } from 'react';
import { ActionIcon, Text, ThemeIcon, Tooltip } from "@mantine/core";
import { IconEdit, IconPlayerPlay, IconTrash } from "@tabler/icons";
import style from "./style.module.css"
import { Handle, useReactFlow } from "reactflow";
import LoadIcon from "../../Icon/LoadIcon";
import IconComment from "../../Icon/IconComment";
import CommentModal from "../../Modal/CommentModal/CommentModal";
import { DataFlowContext } from "../../../core/context/DataFlowContext";
import { AppSettingsContext } from "../../../core/context/AppSettingsContext";

function IfCode({ id, data, isConnectable }) {
  const { nodeActive } = useContext(AppSettingsContext);
  const { setNodes } = useReactFlow();
  const [isCommentOpen, setIsCommentOpen] = useState(false);
  const [comment, setComment] = useState(data.comment || '');
  const [commentHistory, setCommentHistory] = useState([data.comment || '']);
  const dataFlowContext = useContext(DataFlowContext);
  const isActive = nodeActive?.id === id;

  const handleStartNode = (e) => {
    e.stopPropagation();
    data.onStartOneNode(id)
  }

  const handleRemoveNode = (e) => {
    e.stopPropagation();
    data.onRemoveNode(id);
  }

  const handleOpenNode = (e) => {
    e.stopPropagation();
    data.onUpdateNode(id)
  }

  const handleOpenComment = (e) => {
    e.stopPropagation();
    setIsCommentOpen(true);
  };

    const handleCloseComment = (newComment) => {
        if (newComment !== undefined && newComment !== comment) {
            setCommentHistory(prev => [...prev, comment]);
            setComment(newComment);
            // Update React Flow nodes
            setNodes(prev => prev.map(node => node.id === id ? { ...node, data: { ...node.data, comment: newComment } } : node));
        }
        setIsCommentOpen(false);
    };

    const handleCommentChange = (newComment) => {
        if (newComment !== comment) {
            setCommentHistory(prev => [...prev, comment]);
            setComment(newComment);
            // Update React Flow nodes
            setNodes(prev => prev.map(node => node.id === id ? { ...node, data: { ...node.data, comment: newComment } } : node));
        }
    };

  const handleRollbackComment = () => {
    if (commentHistory.length > 0) {
      const previousComment = commentHistory[commentHistory.length - 1];
      setCommentHistory(prev => prev.slice(0, -1));
      setComment(previousComment);
      dataFlowContext.setComment(prev => ({
        ...prev,
        [id]: previousComment
      }));
    }
  };

  return (
    <div>
      <div className='action-node-top' style={{ display: 'flex', gap: '4px', justifyContent: 'flex-end', marginBottom: '4px' }}>
        <ActionIcon onClick={handleOpenComment} color="blue" size="sm" radius="xl">
          <IconComment size={14} />
        </ActionIcon>
        <ActionIcon onClick={handleStartNode} color="green" size="sm" radius="xl">
          <IconPlayerPlay size={14} />
        </ActionIcon>
        <ActionIcon onClick={handleOpenNode} color="blue" size="sm" radius="xl">
          <IconEdit size={14} />
        </ActionIcon>
        <ActionIcon onClick={handleRemoveNode} color="red" size="sm" radius="xl">
          <IconTrash size={14} />
        </ActionIcon>
      </div>
      <div className={`${style.node_normal} node-normal ${isActive && 'active'}`} style={{
        height: `${(data?.options?.conditions?.length - 1) * 16 + 46}px`
      }}>
        <div className='node-normal-body'>
          <ThemeIcon className="node-icon">
            <LoadIcon icon={data.icon} size={16} />
          </ThemeIcon>
          <Text size="0.8rem">{data.label}</Text>
        </div>
        <Handle
          id={`in-${id}`}
          type="target"
          position="left"
          style={{ background: "var(--input)", left: "-6px" }}
          isConnectable={isConnectable}
        />
        {data?.options?.conditions.map((_, index) => (
          <Handle
            id={`success-condition-${index}-${id}`}
            type="source"
            key={index}
            position="right"
            style={{ background: "var(--output)", top: `${index * 16 + 15}px` }}
            isConnectable={isConnectable}
          />
        ))}
        <Handle
          id={`error-${id}`}
          type="source"
          position="right"
          style={{ background: "var(--output-bottom)", top: `${data?.options?.conditions?.length * 16 + 15}px` }}
          isConnectable={isConnectable}
        />
      </div>
      {comment && <div
        onDoubleClick={(e) => e.stopPropagation()}
        onClick={handleOpenComment}
        className="comment-node-normal"
      >
        
          <Tooltip
            label={comment}
            multiline
            width="auto"
            position="bottom"
            withArrow
            openDelay={0}
            closeDelay={200}
            events={{ hover: true, focus: true, touch: true }}
            styles={{
              tooltip: {
                maxWidth: '500px',
                whiteSpace: 'pre-wrap',
                fontSize: '12px',
                lineHeight: '1.6',
                padding: '8px 12px',
                background: 'rgba(246, 242, 242, 0.95)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                color: '#000',
                maxHeight: 'none',
                overflowY: 'hidden !important'
              }
            }}
          >
            <Text size="xs" color="dimmed" lineClamp={3} style={{
              display: '-webkit-box',
              WebkitLineClamp: '3',
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}>
              {comment}
            </Text>
          </Tooltip>
      </div>}
      <CommentModal
        isOpen={isCommentOpen}
        onClose={handleCloseComment}
        onRollback={handleRollbackComment}
        comment={comment}
        onCommentChange={handleCommentChange}
        hasPreviousComment={commentHistory.length > 0}
      />
    </div>
  );
}

export default IfCode;